// material-ui
import { useTheme } from '@mui/material/styles';
import React, { useState, useEffect } from 'react';

import {
  Box,
  Grid,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Divider,
  Alert,
  Backdrop,
  CircularProgress,
  Tooltip,
  IconButton,
  Pagination
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import axios from 'src/utils/axios';
import PrintIcon from '@mui/icons-material/Print';
import ExcelFileCreator from 'src/components/ExcelFileCreator';

// ==============================|| PROFILE 1 - CHANGE PASSWORD ||============================== //

const styles = {
  ul: {
    '& .MuiPaginationItem-root': {
      '&.Mui-selected': {
        background: '#FF9800',
        color: 'white',
        borderRadius: '50%',
      },
    },
  },
  backdrop: (theme) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  }),
  responsiveContainer: (theme) => ({
    marginTop: theme.spacing(3),
    [theme.breakpoints.between('md', 'lg')]: {
      maxHeight: '70vh',
      overflowX: 'hidden',
      overflowY: 'scroll'
    },
    [theme.breakpoints.down('sm')]: {
      maxHeight: '60vh',
      overflow: 'scroll'
    }
  }),
};

const History = ({ EmployeeNr, OrganizationTypeId }) => {
  const theme = useTheme();

  if (EmployeeNr === 0) {
    return (
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
            sm: 12,
            md: 12
          }}>
          <Alert variant="outlined" severity="error" sx={{ borderColor: theme.palette.warning.dark }}>
            <Typography variant='h5' style={{ color: 'red' }}>Önce Kayıt İşlemini Tamamlamanız Gerekli!....
            </Typography>
          </Alert>      </Grid>
      </Grid>
    );
  }
  const [historyData, setHistoryData] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [OrganizationControl, setOrganizationControl] = useState('0');
  const itemsPerPage = 4;
  useEffect(() => {
    setLoading(true);
    axios.get(`GetEmplayeeHistory/${EmployeeNr}`)
      .then((response) => {
        setLoading(false);
        if (response?.data.length > 0) {
          setHistoryData(response.data);
          setOrganizationControl(response.data[0]?.teknisyenNo);
        } else {
          setHistoryData([]);
        }
      });
  }, []);


  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleExportClick = () => {
    var exportData = [];
    const includeCinsiyet = OrganizationTypeId === 1;

    historyData?.map((item) => {
      let dataItem = {
        "Eleman No": item.elemanNo,
        "Sicil No": item.sicilNo,
        "Teknisyen No": item.teknisyenNo,
        "Durum": item.durum,
        "Koç Ailem": item.kocAilemDurumu,
        "İsim": item.isim,
        "Soyisim": item.soyisim,
        "Çalışan Tipi": item.calisanTipi,
        "TC Kimlik No": item.TCKimlikNo,
        "Doğum Yeri": item.dogumYeri,
        "Doğum Tarihi": item.dogumTarihi,
        "Email": item.email,
        "Bölüm": item.bolum,
        "Cep Telefonu": item.cepTelefonu,
        "İlk İşe Giriş Tarihi": item.ilkGirisTarihi,
        "İlgili İşe Giriş Tarihi": item.girisTarihi,
        "Ayrılış Tarihi": item.ayrilisTarihi,
        "Ayrılık Sebebi": item.ayrilikSebebi,
        "Ehliyet": item.ehliyet,
        "Öğrenim": item.ogrenim,
        "İl": item.il,
        "İlçe": item.ilce,
        "Adres": item.adres,
        "Kayıt Tarihi": item.KAYIT_TARIHI,
      };

      if (includeCinsiyet) {
        dataItem["Cinsiyet"] = item.cinsiyet;
        dataItem["Askerlik"] = item.askerlikDurumu;
      }

      exportData.push(dataItem);
    });

    ExcelFileCreator(exportData, `${EmployeeNr} - Çalışan Log`);
  };


  // Mevcut sayfadaki verileri al
  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = page * itemsPerPage;
  const paginatedData = historyData?.slice(startIndex, endIndex);
  return (
    <>
      {
        loading ?
          <Backdrop sx={styles.backdrop} open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          : ''
      }
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid>
            <Typography variant="h5">Çalışan Log</Typography>
          </Grid>
          <Grid>
            <Pagination
              count={Math.ceil(historyData?.length / itemsPerPage)}
              page={page}
              onChange={handlePageChange}
              variant="outlined"
              sx={styles.ul}
            />
          </Grid>
          <Grid>
            <Tooltip title="Yazdır">
              <IconButton size="large" onClick={handleExportClick}>
                <PrintIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
        <Divider sx={{ mb: 2 }} />
        <Box sx={{ maxHeight: 400, overflowY: 'auto' }}>
              <TableContainer >
                <Table stickyHeader aria-label="sticky table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>ElemanNo</TableCell>
                      <TableCell>SicilNo</TableCell>
                      {OrganizationControl !== '-1' ? <TableCell>TeknisyenNo</TableCell> : ''}
                      <TableCell>Durum</TableCell>
                      <TableCell>KoçAilem</TableCell>
                      <TableCell>İsim</TableCell>
                      <TableCell>Soyisim</TableCell>
                      {OrganizationTypeId === 1 ? <TableCell>Cinsiyet</TableCell> : null}
                      <TableCell>ÇalışanTipi</TableCell>
                      <TableCell>TCKimlikNo</TableCell>
                      <TableCell>DoğumYeri</TableCell>
                      <TableCell>DoğumTarihi</TableCell>
                      {OrganizationTypeId === 1 ? <TableCell>Askerlik</TableCell>: null}
                      <TableCell>Email</TableCell>
                      <TableCell>Bölüm</TableCell>
                      <TableCell>CepTelefonu</TableCell>
                      <TableCell>İlkİşeGirişTarihi</TableCell>
                      <TableCell>İlgiliİşeGirişTarihi</TableCell>
                      <TableCell>AyrılışTarihi</TableCell>
                      <TableCell>AyrılıkSebebi</TableCell>
                      <TableCell>Ehliyet</TableCell>
                      <TableCell>Öğrenim</TableCell>
                      <TableCell>İl</TableCell>
                      <TableCell>İlçe</TableCell>
                      <TableCell>Adres</TableCell>
                      <TableCell>KayıtTarihi</TableCell>
                      <TableCell>Değişiklik Yapan</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {historyData.slice((page - 1) * itemsPerPage, page * itemsPerPage).map((item) => (
                      <TableRow key={item.id}>
                        <TableCell>{item.elemanNo}</TableCell>
                        <TableCell>{item.sicilNo}</TableCell>
                        {item.teknisyenNo !== "-1" ? <TableCell>{item.teknisyenNo}</TableCell> : ''}
                        <TableCell>{item.durum}</TableCell>
                        <TableCell>{item.kocAilemDurumu}</TableCell>
                        <TableCell>{item.isim}</TableCell>
                        <TableCell>{item.soyisim}</TableCell>
                        {OrganizationTypeId === 1 ? <TableCell>{item.cinsiyet}</TableCell> : null}
                        <TableCell>{item.calisanTipi}</TableCell>
                        <TableCell>{item.TCKimlikNo}</TableCell>
                        <TableCell>{item.dogumYeri}</TableCell>
                        <TableCell>{item.dogumTarihi}</TableCell>
                        {OrganizationTypeId === 1 ? <TableCell>{item.askerlikDurumu}</TableCell>: null}
                        <TableCell>{item.email}</TableCell>
                        <TableCell>{item.bolum}</TableCell>
                        <TableCell>{item.cepTelefonu}</TableCell>
                        <TableCell>{item.ilkGirisTarihi}</TableCell>
                        <TableCell>{item.girisTarihi}</TableCell>
                        <TableCell>{item.ayrilisTarihi}</TableCell>
                        <TableCell>{item.ayrilikSebebi}</TableCell>
                        <TableCell>{item.ehliyet}</TableCell>
                        <TableCell>{item.ogrenim}</TableCell>
                        <TableCell>{item.il}</TableCell>
                        <TableCell>{item.ilce}</TableCell>
                        <TableCell>{item.adres.substring(0, 4) + '...'}</TableCell>
                        <TableCell>{item.KAYIT_TARIHI}</TableCell>
                        <TableCell>{item.SonDegisiklikYapan}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
        </Box>
      </LocalizationProvider>
    </>
  );
};

export default History;
